var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.MOON_PHASE = {
    NEW: 'NEW',
    WAXING_CRESCENT: 'WAXING_CRESCENT',
    FIRST_QUARTER: 'FIRST_QUARTER',
    WAXING_GIBBOUS: 'WAXING_GIBBOUS',
    FULL: 'FULL',
    WANING_GIBBOUS: 'WANING_GIBBOUS',
    THIRD_QUARTER: 'THIRD_QUARTER',
    WANING_CRESCENT: 'WANING_CRESCENT'
};

Object.freeze(Enum.MEEDY.MOON_PHASE);